import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import PhoneInputWithCountry from "react-phone-number-input/react-hook-form";
import "react-phone-number-input/style.css";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { cn } from "../shared/utils";
import { Calendar } from "./ui/calendar";
import { CalendarIcon, Spinner } from "../shared/svgIcon";
import { differenceInYears, format } from "date-fns";
import { RadioGroup, RadioGroupItem } from "./ui/radioGroup";
import { consumerRegister, sendOtp } from "../lib/api";
import { parsePhoneNumber } from "react-phone-number-input";
import { useStore } from "../store";
import RegisterFacility from "./facility/registerFacility";
export default function SignUp(props) {
  const selectedHospitals = useStore((state) => state.selectedHospitals);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [isShowFacilityList, setShowFacilityList] = useState(false);

  const currentYear = new Date().getFullYear();
  let navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm();

  const signUp = async (payload) => {
    try {
      console.log("sign", payload);
      setError("");
      setLoading(true);
      const res = await consumerRegister(payload);
      console.log(res);

      if (res?.isSuccess) {
        console.log(res?.data?.result?.consumer_id);
        localStorage.setItem("patientId", res?.data?.result?.consumer_id);
        const data = await sendOtp({
          consumer_id: res?.data?.result?.consumer_id,
          type: "phone",
        });
        sessionStorage.setItem("isKiosk", true);
        const patientPhone = payload?.contact?.find(
          (e) => e.type == "phone"
        )?.value;
        if (patientPhone) sessionStorage.setItem("patientPhone", patientPhone);
        sessionStorage.setItem("otp_timeout", data?.data?.result?.otp_timeout);
        navigate("/otp");
      } else {
        setError(res?.data?.message || "try again");
        setLoading(false);
      }
    } catch (error) {
      console.log(error, "rr");
      setLoading(false);
    }
  };

  const onSubmit = (data) => {
    // console.log("payload", data);
    const currentDate = new Date();
    const birthDate = new Date(data.dob);
    const age = differenceInYears(currentDate, birthDate);
    const formattedDate = format(new Date(data.dob), "yyyy-MM-dd");
    let country_code = "";
    if (data?.phone) {
      const phoneNumber = parsePhoneNumber(data?.phone);
      country_code = phoneNumber?.country || "";
    }

    const payload = {
      name: data.name,
      age: age,
      dob: formattedDate,
      gender: data.gender,
      picture: "",
      contact: [
        {
          value: data.email || "",
          category: "primary",
          type: "email",
          is_verified: false,
        },
        {
          value: data.phone,
          category: "primary",
          type: "phone",
          country_code: country_code,
          is_verified: false,
        },
      ],
      source: {
        identifier: "654cc54350349ba664618567",
        location: "",
        name: "",
        classification: "mobile",
      },
      organizations: selectedHospitals.map((e) => e?.id) || [],
    };
    // console.log(payload, "payload");
    signUp(payload);
  };

  const handleOnSelect = (date) => {
    setIsPopoverOpen(false);
  };
  const gender = [
    { name: "Male", value: "M" },
    { name: "Female", value: "F" },
    { name: "Other", value: "O" },
  ];
  const gotoFacility = () => {
    setShowFacilityList(true);
  };
  return (
    <>
      {!isShowFacilityList ? (
        <div className="bg-primary text-white   relative  flex flex-col min-dh-screen">
          <div className="z-20 relative px-6 py-4  sm:w-3/5 ">
            <div className="flex w-full">
              <div className="flex-1 mt-4 mx-auto">
                <img
                  src="../../../images/Logo.svg"
                  alt="logo"
                  className="mb-4"
                />
              </div>
            </div>

            <div className="text-left font-semibold mb-2">
              <>
                <span className="text-xl capitalize">
                  Please enter <br /> your basic information
                </span>{" "}
                <br />
              </>
            </div>
          </div>
          <div className="overflow-hidden bg-white w-full  rounded-t-xl flex flex-col sm:w-3/5 mx-auto text-black flex-1">
            <div className="flex flex-col  pt-4 mx-2 flex-1">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="flex flex-col gap-2">
                  <div className="w-full">
                    <label
                      htmlFor="name"
                      className="text-black text-base font-medium font-['SF Pro Display'] pl-1 mb-3"
                    >
                      Name
                    </label>
                    <div className="flex">
                      <input
                        {...register("name", {
                          required: true,
                        })}
                        id="name"
                        name="name"
                        type="text"
                        autoComplete="off"
                        autoCorrect="off"
                        className="w-full bg-gray-200  flex  rounded-lg border border-input  px-3 py-2 mt-2 text-base shadow-sm transition-colors   focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                      />{" "}
                    </div>

                    {errors.name && (
                      <p className="py-2 text-xs text-red-500">{"required"}</p>
                    )}
                  </div>
                  <div className="w-full">
                    <label
                      htmlFor="gender"
                      className="text-black text-base font-medium font-['SF Pro Display'] pl-1 mb-3"
                    >
                      Gender
                    </label>
                    <Controller
                      name="gender"
                      control={control}
                      defaultValue={null}
                      rules={{ required: "Gender is required" }}
                      render={({ field }) => (
                        <RadioGroup
                          onValueChange={field.onChange}
                          defaultValue={field.value}
                          className="flex flex-row gap-3 pl-1 py-1"
                        >
                          {gender.map((e, index) => (
                            <div
                              key={index}
                              className="flex items-center space-x-2 "
                            >
                              <RadioGroupItem value={e.value} id={index} />
                              <label className="cursor-pointer" htmlFor={index}>
                                {e.name}
                              </label>
                            </div>
                          ))}
                        </RadioGroup>
                      )}
                    />
                    {errors.gender && (
                      <p className="py-2 text-xs text-red-500">{"required"}</p>
                    )}
                  </div>

                  <div className="w-full flex flex-col">
                    <label
                      htmlFor="dob"
                      className="text-black text-base font-medium font-['SF Pro Display'] pl-1 mb-3"
                    >
                      Date of birth
                    </label>
                    <Controller
                      name="dob"
                      control={control}
                      defaultValue={null}
                      rules={{ required: "dob is required" }}
                      render={({ field }) => (
                        <Popover
                          open={isPopoverOpen}
                          onOpenChange={setIsPopoverOpen}
                        >
                          <PopoverTrigger asChild>
                            <button
                              className={cn(
                                "border border-input ",
                                "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
                                "w-full justify-start text-left font-normal",
                                "h-10 px-2 py-2 bg-gray-200",
                                !field.value && "text-muted-foreground"
                              )}
                            >
                              <CalendarIcon className="mr-2 h-4 w-4" />
                              {field.value ? (
                                format(field.value, "PPP")
                              ) : (
                                <span>Pick a date</span>
                              )}
                            </button>
                          </PopoverTrigger>
                          <PopoverContent className="w-full p-0">
                            <Calendar
                              mode="single"
                              captionLayout="dropdown-buttons"
                              fromYear={currentYear - 100}
                              toYear={currentYear}
                              defaultMonth={field.value}
                              selected={field.value}
                              onSelect={(e) => {
                                field.onChange(e);
                                handleOnSelect();
                              }}
                              disabled={(date) =>
                                date > new Date() ||
                                date < new Date("1900-01-01")
                              }
                              initialFocus
                              className="w-full"
                            />
                          </PopoverContent>
                        </Popover>
                      )}
                    />
                    {errors.dob && (
                      <p className="py-2 text-xs text-red-500">{"required"}</p>
                    )}
                  </div>
                  <div className="w-full">
                    <label
                      htmlFor="phone"
                      className="text-black text-base font-medium font-['SF Pro Display'] pl-1 mb-3"
                    >
                      Phone
                    </label>
                    <div className="flex">
                      <PhoneInputWithCountry
                        name="phone"
                        control={control}
                        rules={{ required: true }}
                        international
                        countryCallingCodeEditable={false}
                        defaultCountry="IN"
                        autoComplete="off"
                        numberInputProps={{
                          className: " bg-gray-200 focus-visible:outline-none",
                        }}
                        className=" bg-gray-200  flex  w-full rounded-lg border border-input  px-3 py-2 mt-2 text-base shadow-sm transition-colors   focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                      />
                    </div>

                    {errors.phone && (
                      <p className="py-2 text-xs text-red-500">{"required"}</p>
                    )}
                  </div>
                  <div className="w-full ">
                    <label
                      htmlFor="email"
                      className="text-black text-base font-medium  font-['SF Pro Display'] pl-3 pb-2"
                    >
                      Email(optional)
                    </label>
                    <input
                      {...register("email", {
                        required: false,
                      })}
                      id="email"
                      name="email"
                      type="text"
                      autoComplete="off"
                      autoCorrect="off"
                      className=" bg-gray-200  flex  w-full rounded-lg border border-input  px-3 py-2 mt-2 text-base shadow-sm transition-colors   focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                    />
                    {errors.email && (
                      <p className="py-2 text-xs text-red-500">{"required"}</p>
                    )}
                  </div>
                  {error && (
                    <div className="pt-2 text-red-600 text-sm">{error}</div>
                  )}
                  <div className="w-full ">
                    <label
                      htmlFor="facility"
                      className="text-black text-base font-medium  font-['SF Pro Display'] pl-3 pb-2"
                    >
                      Hospital/Facility
                    </label>
                    <div
                      className=" bg-gray-200  flex  w-full rounded-lg border border-input  px-3 py-2 mt-2 h-10 text-base shadow-sm transition-colors   focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                      onClick={gotoFacility}
                    >
                      {selectedHospitals?.length > 0
                        ? `${selectedHospitals.length} selected`
                        : "select Hospital"}
                    </div>
                  </div>
                </div>
                <div className="flex justify-end w-full gap-2 ">
                  <button
                    className="bg-primary rounded-[100px] text-center flex shadow  mt-4   w-3/4 mx-auto"
                    type="submit"
                  >
                    <div className="text-white  font-semibold font-['SF Pro Display']  flex justify-center items-center px-4 py-3 w-full">
                      {isLoading && (
                        <Spinner className="mr-2 h-4 w-4 animate-spin" />
                      )}{" "}
                      Submit
                    </div>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      ) : (
        <div className="bg-gray-50 min-sh-screen">
          <RegisterFacility
            selectedHospitals={selectedHospitals || []}
            isEnableDeleteConfirm={false}
            onHandleBack={() => setShowFacilityList(false)}
            onUpdate={() => setShowFacilityList(false)}
          />
        </div>
      )}
    </>
  );
}
